import abbyDevtools from '@tryabby/devtools';
import { withDevtools } from './abby';

export const AbbyDevtools = withDevtools(abbyDevtools, { defaultShow: true });
